import React from "react";
import { FaWarehouse } from "react-icons/fa";

const RackSidebar = ({ racks, selectedRack, onRackSelect }) => (
  <aside className="w-64 bg-white text-gray-800 flex-shrink-0 ">
    {/* Sidebar Header */}
    <div className="p-6 text-2xl font-semibold border-b border-gray-300 flex items-center space-x-2">
      <FaWarehouse className="text-[#4CAF50]" />
      <span>Racks</span>
    </div>

    {/* Navigation Items */}
    <nav className="mt-4 space-y-2 px-4">
      {racks?.map((rack) => (
        <button
          key={rack?.rack_name}
          onClick={() => onRackSelect(rack.rack_name)}
          className={`w-full flex items-center space-x-3 px-4 py-3 text-sm font-medium rounded-lg transition-all ${
            selectedRack === rack.rack_name
              ? "bg-[#4CAF50] text-white shadow-md"
              : "hover:bg-[#EAEAEA] hover:text-gray-800 text-gray-600"
          }`}
        >
          {/* Rack Initial Icon */}
          <div
            className={`w-8 h-8 flex items-center justify-center rounded-full font-bold ${
              selectedRack === rack.name
                ? "bg-white text-[#4CAF50]"
                : "bg-[#4CAF50] text-white"
            }`}
          >
            {rack?.rack_name[0]}
          </div>
          <span className="truncate">{rack.rack_name}</span>
        </button>
      ))}
    </nav>
  </aside>
);

export default RackSidebar;
